import React, { useState } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { v4 as uuidv4 } from 'uuid';

import { QuestionnaireLabel } from 'src/styles/QuestionnaireLabel.styled';

import vw from 'src/styles/utils';
import media from 'src/styles/media';

export const RadioButtonSection = (props) => {
  const {
    data,
    title,
    name,
    other,
    otherText,
    abstract,
    checkedSections,
    setCheckedSections,
  } = props;

  const [otherInputValue, setOtherInputValue] = useState(otherText || 'Other');
  const [activeButton, setActiveButton] = useState('');
  const [otherChecked, setOtherChecked] = useState(false);
  const [isChecked, setIsChecked] = useState(false);

  const sortedData = [...data].sort((a, b) =>
    a.value.toLowerCase().localeCompare(b.value.toLowerCase())
  );

  const handleChange = (e) => {
    if (e.target.dataset.title === 'option') {
      setIsChecked(true);
      if (!checkedSections.includes(name)) {
        setCheckedSections([...checkedSections, name]);
      }
      setOtherChecked(false);
      setOtherInputValue('Other');
      if (e.target.id === activeButton) setActiveButton('');
      if (e.target.id !== activeButton) setActiveButton(e.target.id);
    } else if (e.target.dataset.title === 'other') {
      setIsChecked(true);
      if (!checkedSections.includes(name)) {
        setCheckedSections([...checkedSections, name]);
      }
      if (otherChecked) {
        setActiveButton('');
        setOtherChecked(false);
      } else {
        setActiveButton('other');
        setOtherChecked(true);
      }
    } else if (e.target.dataset.title === 'othertextinput') {
      // console.log('othertextinput');
      setOtherInputValue(e.target.value);
    }
  };
  {
    /* <label class="container">One
  <input type="checkbox" checked="checked">
  <span class="checkmark"></span>
</label> */
  }
  return (
    <Root>
      <QuestionnaireLabel>{title}</QuestionnaireLabel>
      <Container onChange={(e) => handleChange(e)}>
        {(abstract ? data : sortedData).map((item, index) =>
          index === 0 ? (
            <div>
              <CustomLabel key={uuidv4()} htmlFor={name + index}>
                {item.value}
                <input
                  required
                  data-parent={name}
                  data-question={title}
                  type="radio"
                  id={name + index}
                  name={name}
                  data-title="option"
                  data-priority="0"
                  value={item.value}
                  checked={name + index === activeButton ? true : false}
                />
                <CustomSpan></CustomSpan>
                {/* <input
                required
                data-parent={name}
                data-question={title}
                type="radio"
                id={name + index}
                name={name}
                data-title="option"
                data-priority="0"
                value={item.value}
                checked={name + index === activeButton ? true : false}
                // onChange={() => setActiveButton(name + index)}
              />
              <label htmlFor={name + index}>{item.value}</label> */}
              </CustomLabel>
            </div>
          ) : (
            <div>
              <CustomLabel key={uuidv4()} htmlFor={name + index}>
                {item.value}
                <input
                  data-parent={name}
                  data-question={title}
                  type="radio"
                  id={name + index}
                  name={name}
                  data-title="option"
                  data-priority="0"
                  value={item.value}
                  checked={name + index === activeButton ? true : false}
                />
                <CustomSpan></CustomSpan>
                {/* <input
                data-parent={name}
                data-question={title}
                type="radio"
                id={name + index}
                name={name}
                data-title="option"
                data-priority="0"
                value={item.value}
                checked={name + index === activeButton ? true : false}
                // onChange={() => setActiveButton(name + index)}
              />
              <label htmlFor={name + index}>{item.value}</label> */}
              </CustomLabel>
            </div>
          )
        )}

        {other ? (
          <OtherRadio>
            {/* new code */}
            <CustomLabel htmlFor={name + otherText || 'Other'}>
              {otherText || 'Other'}:
              <input
                type="radio"
                data-parent={name}
                id={name + otherText || 'Other'}
                name={name}
                data-title="other"
                data-priority="0"
                value={otherChecked ? otherInputValue : otherText || 'Other'}
                checked={otherChecked}
              />
              <CustomSpan></CustomSpan>
            </CustomLabel>
            {/* old code */}
            {/* <input
              type="radio"
              data-parent={name}
              id={name + otherText || 'Other'}
              name={name}
              data-title="other"
              data-priority="0"
              value={otherChecked ? otherInputValue : otherText || 'Other'}
              checked={otherChecked}
            />
            <label htmlFor={name + otherText || 'Other'}>
              {otherText || 'Other'}:
            </label> */}
            <OtherInput
              type="text"
              data-parent={name}
              disabled={activeButton !== 'other'}
              data-title="othertextinput"
              onChange={(e) => handleChange(e)}
              value={
                otherInputValue !== 'Other' || otherInputValue !== otherText
                  ? otherInputValue
                  : ''
              }
            />
          </OtherRadio>
        ) : null}
      </Container>
    </Root>
  );
};

RadioButtonSection.propTypes = {
  otherText: PropTypes.string,
};

RadioButtonSection.defaultProps = {
  otherText: 'Other',
};

const CustomLabel = styled.label`
  /* Customize the label (the container) */
  display: inline-block;

  position: relative;
  top: 4px;
  ${vw('padding-left', 29, 35, 37)};
  margin-bottom: 12px;
  cursor: pointer;
  /* font-size: 22px; */
  ${vw('font-size', 13, 16)}
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;

  /* Hide the browser's default radio button */
  input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }

  /* On mouse-over, add a grey background color */
  &:hover input ~ span {
    /* background-color: #ccc; */
  }

  /* When the radio button is checked, add a blue background */
  input:checked ~ span {
    background-color: #fff;
  }

  /* Show the indicator (dot/circle) when checked */
  input:checked ~ span:after {
    display: block;
    background-color: #de5647;
    ${vw('width', 20, 25)}
    ${vw('height', 21, 25)}
  }
`;

const CustomSpan = styled.span`
  /* Create a custom radio button */
  margin-bottom: 50px;
  position: absolute;
  top: -4px;
  left: 0;
  /* height: 25px;
  width: 25px; */
  ${vw('width', 20, 25)}
  ${vw('height', 20, 25)}
  
  background-color: #fff;
  border: 1px solid #de5647;
  border-radius: 50%;

  /* Create the indicator (the dot/circle - hidden when not checked) */
  &:after {
    content: '';
    position: absolute;
    display: none;
  }

  /* Style the indicator (dot/circle) */
  &:after {
    top: -1px;
    left: -1px;
    /* width: 8px; */
    /* height: 8px; */
    border-radius: 50%;
    background: white;
  }
`;

const OtherInput = styled.input`
  /* Input box next to the other label */
  ${vw('margin-left', 6, 6)}
  ${vw('font-size', 14, 15)}
  ${vw('line-height', 22, 26)}
  ${vw('padding-left', 20, 10)}
  ${vw('padding-bottom', 8, 8)}
  border: 1px solid #e1e1e1;
  box-sizing: border-box;
  color: #747474;
  ${vw('height', 25)}
  ${vw('font-size', 13, 15)}

  &:disabled {
    opacity: 0.5;
    background: #e1e1e1;
  }
`;

const Title = styled.p`
  text-transform: uppercase;
  .error {
    color: red;
  }
`;

const Root = styled.section`
  &.error p {
    color: red;
    &:after {
      content: ' This field is required.';
      color: black;
      font-weight: light;
      font-style: italic;
      text-transform: capitalize;
    }
  }
`;

const OtherRadio = styled.div`
  position: relative;
  /* top: -10px; */
`;

const Container = styled.div`
  /* Margin between containers  */
  ${vw('margin-top', 10, 18)}

  ${vw('margin-bottom', 40)}

  @media ${media.desktop} {
    columns: 2;
  }

  div {
    ${vw('margin-bottom', 5, 5, 10)}
  }

  /* div {
    display: flex;
    flex-direction: row;
    justify-content: left;
    align-items: top;
    padding-top: 2px;
    ${vw('margin-bottom', 15)}

    label {
      ${vw('font-size', 14, 15)}
      ${vw('line-height', 22, 26)}
    ${vw('padding-left', 20, 28)}
    }

    label:hover {
      cursor: pointer;
    }

    input[type='radio'] {
      visibility: hidden;
      -moz-appearance: radio !important;
      &:hover {
        cursor: pointer;
      }
    }
    input[type='radio']:after {
      -moz-appearance: radio !important;

      ${vw('width', 20, 25)}
      ${vw('height', 21, 25)}
        border-radius: 15px;
      top: -2px;
      left: -1px;
      position: relative;
      background-color: #fff;
      content: '';
      display: inline-block;
      visibility: visible;
      border: 1px solid #de5647;
    }

    input[type='radio']:checked:after {
      ${vw('width', 20, 25)}
      ${vw('height', 21, 25)}
        border-radius: 15px;
      top: 0px;
      left: 0px;
      position: relative;
      background-color: #de5647;
      content: '';
      display: inline-block;
      visibility: visible;
      border: 0px solid #747474;
    }
  } */
`;
